export default {"src":"/_next/static/image/public/images/flags/flag_372.f394a426db0ed5bb4ea4c36997b7f363.svg","height":16,"width":24};